<template>
  <div class="container-fluid checkout-summary">
    <h5 class="text-center mb-4 font-weight-bold">Checkout Summary</h5>

    <!-- 🎬 Movie Details (conditional) -->
    <div v-if="showDataArr && showDataArr.length" class="movie-details mb-3">
      <p class="font-weight-bold text-center">
        {{ showDataArr[0].movie_name }} - {{ showDataArr[0].mf_lang_name }} -
        {{ showDataArr[0].rating }} |
        {{ showDataArr[0].screen_name }}
      </p>
    </div>

    <!-- 📋 Items Table -->
    <table class="table table-bordered text-center summary-table">
      <thead class="thead-light">
        <tr>
          <th>Item</th>
          <th>Quantity</th>
          <th>Total</th>
        </tr>
      </thead>

      <tbody>
        <!-- 🎟️ Movie Tickets -->
        <tr v-for="(fnbitem, fnbitemKey) in fnbList" :key="fnbitemKey">
          <td class="text-left">
            {{ fnbitem.item_name }}
          </td>
          <td>{{ fnbitem.quantity }}</td>
          <td class="text-right">
            {{ currCode }}
            {{
              currFormat(fnbitem.fp_total_amount * fnbitem.quantity)
            }}
          </td>
        </tr>

        <!-- Subtotal -->
        <tr>
          <td colspan="2" class="text-right font-weight-bold">Sub Total :</td>
          <td class="text-right">
            {{ currCode }} {{ currFormat(subTotal) }}
          </td>
        </tr>

        <!-- Tax -->
        <tr>
          <td colspan="2" class="text-right font-weight-bold">Tax</td>
          <td class="text-right">
            {{ currCode }} {{ currFormat(grossTotal - subTotal) }}
          </td>
        </tr>

        <tr v-if="RateCardAddonsChargesFinalAmount > 0">
          <td>Additional Charges</td>
          <td class="text-right">
            {{ currCode }}
            {{ currFormat(RateCardAddonsChargesFinalAmount || 0) }}
          </td>
        </tr>

        <!-- Discount (if any) -->
        <tr
          v-for="(deduction, deductionIndex) in deductionArray"
          :key="deductionIndex"
        >
          <td colspan="2" class="text-right text-danger font-weight-bold">
            {{ deduction.deduction_name }}
          </td>
          <td class="text-danger text-right">
            - {{ currCode }} {{ currFormat(deduction.amount) }}
          </td>
        </tr>
      </tbody>
    </table>

    <!-- ✅ Gross Total -->
    <div class="gross-total text-center mt-3">
      <h4 class="font-weight-bold">
        Gross Total :
        <span class="text-success"
          >{{ currCode }} {{ currFormat(grossFinalAmt) }}</span
        >
      </h4>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fnbList: {
      type: Array,
    },
    deductionArray: {
      type: Array,
    },
    fnbtotalamount: {
      type: Number,
    },
    currCode: {
      type: String,
    },
    charges: {
      type: Array,
    },
    showDataArr: {
      type: Array,
    },
    offerData: {
      type: Array,
    },
    RateCardAddonsChargesFinalAmount: {
      type: Number,
    },
    finalAmountToPay: {
      type: Number,
    },
    addonArray: {
      type: Array,
    },
  },
  computed: {
    subTotal() {
      const fnbList = this.fnbList;

      return fnbList && fnbList.length > 0
        ? this.currFormat(
            fnbList.reduce((ac, x) => (ac += x.fp_amount * x.quantity), 0)
          )
        : "-";
    },
    isEpix() {
      let hostname = window.location.hostname;
      return hostname.includes("epixcinemas");
    },
    grossFinalAmt() {
      return parseFloat(this.finalAmountToPay).toFixed(2);
    },
    grossTotal() {
      const fnbList = this.fnbList;
      const offerData = this.offerData;
      const offerDataValue =
        offerData.length > 0 && offerData[0].offer_price
          ? offerData[0].offer_price
          : 0;
      const RateCardAddonsChargesFinalAmount = this
        .RateCardAddonsChargesFinalAmount
        ? this.RateCardAddonsChargesFinalAmount
        : 0;

      return fnbList && fnbList.length > 0
        ? this.currFormat(
            // fnbList[0].fp_total_amount * fnbList[0].quantity
            fnbList.reduce(
              (ac, x) => (ac += x.fp_total_amount * x.quantity),
              0
            ) +
              RateCardAddonsChargesFinalAmount -
              offerDataValue
          )
        : "-";
    },
  },
};
</script>
<!-- <style scoped>
table {
  width: 100%;
}

table,
th,
td {
  border-bottom: 1px solid #000;
  color: #000;
  font-weight: bold;
  font-size: 16px;
  padding: 10px;
}

.table-bg {
  background-color: #fff;
  height: 100%;
  /* transform: scale(0.7); */
  transform: top;
  /* margin-left: -150px; */
}

.table-light-bg {
  box-shadow: rgb(128 128 128 / 68%) 1px 1px 9px 1px;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 20px;
  border-radius: 20px;
}
</style> -->

<style scoped>
.checkout-summary {
  background: #fff;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
}

.summary-table th,
.summary-table td {
  font-size: 14px;
  vertical-align: middle;
  padding: 0.5rem !important;
}

.gross-total h4 {
  font-size: 16px;
  border-top: 2px solid #000;
  padding-top: 10px;
}
</style>
